const labels = Object.freeze({
  HOME: 'Home',
  MY_ACTIONS: 'My Actions',
  MANAGE_DIGITAL_ASSETS: 'Manage Digital Assets',
  CONTACTS: 'Contacts',
  UPDATE_CONTACT_INFO: 'Update Contact Information',
  CONTACT_INFO: 'Contact Information',
  USER_DETAILS: 'User Details',
  SFT_USER: 'SFT User',
  GET_STARTED: 'Get started',
  LEARN_MORE: 'Learn more',
  UPDATE_PASSWORD: 'Update Password',
  ACTIVATE_FXACCOUNT: 'Activate FileX Account',

  SFT_USER_NM: 'SFT User Name',
  TRANSMITTER_NM: 'Transmitter Name',
  AMEX_CONTACT: 'Amex Contact',
  PROTOCOL: 'Protocol',
  LAST_PWD_CHANGED_TIME: 'Last Password Changed Time',
  STATUS: 'Status',
  ENVIRONMENT: 'Environment',

  ROLE: 'role',

  FX_EXPRESS: 'FileXpress',

  OTP: 'OTP',
  COMPANY_NM: 'Company Name',
  NAME: 'Name',
  USER_ID: 'User ID',
  PASSWORD: 'Password',
  CONFIRM_PASSWORD: 'Confirm Password',
  SECURITY_PIN: 'Security Code',
  AGREEMENT: 'Agreement',

  NEXT: 'Next',
  PREVIOUS: 'Previous',
  SUBMIT: 'Submit',
  VALIDATE: 'Validate',
  CANCEL: 'Cancel',
  LOGIN: 'Login',

  CONTACT_ID: 'Contact Id',
  CONTACT_NM: 'Contact Name',
  CONTACT_FIRST_NM: 'Contact First Name',
  CONTACT_LAST_NM: 'Contact Last Name',
  TRANS_NM: 'FxFamily Name',
  FX_FAMILY_NM: 'FxFamily Name',
  CONTACT_ROLE: 'Role',
  CONTACT_TYPE: 'Contact Type',
  CONTACT_EMAIL: 'Email Address',
  CONTACT_PHNO: 'Phone Number',
  TRANS_ID: 'FxgFamily Id',
  CONTACT_TYPE_TOOLTIP: 'Contact Type is read-only and cannot be changed',
  EMAIL_TOOLTIP: 'Email Address is read-only and cannot be changed',

  DATE: 'Date',
  REQUEST_ID: 'Request ID',
  ACTION: 'Action',
  FX_ACCOUNT_NAME: 'FileX Account Name',
  DIGITAL_ASSETS_GROUP: 'Digital Assets Group',
  RAISED_ON: 'Raised On',
  FX_ACCOUNT: 'FileX Account',
  AMEX_OWNED_ASSETS: 'Amex Owned Assets',
});

export default labels;
